import React from 'react';
import { Button, Link as MuiLink, Slide, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Icons from '../../../../../../../Themes/Icons';
import CustomIcon from '../../../../../../DesignSystem/CustomIcon';
import { PostTypes } from '../../../../../../../Utils/Types';
import { newPostPath } from '../../../../../../../Utils/routes';

function PromptCard({ children, colored = false }: any) {
  return (
    <Stack
      direction="column"
      spacing={2}
      sx={(theme: any) => ({
        alignItems: 'center',
        flex: 1,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        bgcolor: colored ? theme.palette.secondary.light : 'none',
        px: 2,
        py: 7,
      })}
    >
      {children}
    </Stack>
  );
}

const SimpleFab = styled('div')(
  ({ theme, color = 'primary' }: any) => `
    background-color: ${theme.palette[color].main};
    width: ${theme.spacing(6)};
    height: ${theme.spacing(6)};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  `,
);

function PromptStep({
  handleNext,
  setPostsView,
  space,
  parentId,
  openToCitizenAndContributor = true,
}: any) {
  const postFormPath = newPostPath(space.slug, PostTypes.IDEA, {
    parent_id: parentId,
    event_source: 'carousel',
  });

  return (
    <Slide in direction="up" mountOnEnter unmountOnExit>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        sx={{
          flex: 1,
          p: 3,
          display: 'flex',
          minHeight: 420,
        }}
        spacing={3}
      >
        <PromptCard colored>
          <SimpleFab color="primary">
            <HowToVoteIcon sx={{ color: 'primary.contrastText' }} />
          </SimpleFab>
          <Typography variant="body1" align="center">
            <FormattedMessage
              id="POSTS.CAROUSEL.PROMPT.VOTE_CARD.TEXT_1"
              values={{
                emoji: (
                  <span role="img" aria-label="clapping-emoji">
                    👏
                  </span>
                ),
              }}
            />
          </Typography>
          <Typography
            variant="body1"
            sx={(theme: any) => ({
              fontWeight: theme.typography.fontWeightBold,
            })}
          >
            <FormattedMessage id="POSTS.CAROUSEL.PROMPT.VOTE_CARD.TEXT_2" />
          </Typography>
          <Button
            size="large"
            variant="contained"
            startIcon={<PlayCircleIcon />}
            onClick={handleNext}
          >
            <FormattedMessage id="POSTS.CAROUSEL.PROMPT.VOTE_CARD.CTA" />
          </Button>
          <MuiLink
            component="button"
            variant="body2"
            color="inherit"
            onClick={() => setPostsView('list')}
          >
            <FormattedMessage id="POSTS.CAROUSEL.PROMPT.VOTE_CARD.TEXT_3" />
          </MuiLink>
        </PromptCard>

        {openToCitizenAndContributor && (
          <PromptCard>
            <SimpleFab
              sx={(theme: any) => ({
                bgcolor: theme.palette.primary.light,
              })}
            >
              <CustomIcon src={Icons.misc.bulb} color="primary" />
            </SimpleFab>
            <Typography variant="body1">
              <FormattedMessage id="POSTS.CAROUSEL.PROMPT.PROPOSAL_CARD.TEXT_1" />
            </Typography>
            <Typography
              variant="body1"
              sx={(theme: any) => ({
                fontWeight: theme.typography.fontWeightBold,
              })}
            >
              <FormattedMessage id="POSTS.CAROUSEL.PROMPT.PROPOSAL_CARD.TEXT_2" />
            </Typography>
            <Button
              size="large"
              variant="contained"
              component={Link}
              to={postFormPath}
              startIcon={<AddCircleIcon />}
              sx={{ marginBottom: 5 }}
            >
              <FormattedMessage id="POSTS.CAROUSEL.PROMPT.PROPOSAL_CARD.CTA" />
            </Button>
          </PromptCard>
        )}
      </Stack>
    </Slide>
  );
}

export default PromptStep;
